import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const FlagIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path
      fill="currentColor"
      d="M4.286 22.001V3.871h9.68l.452 2.106h5.868v10.826h-7.574l-.453-2.134H6.526v7.332zm10.24-7.438h3.52V8.217h-5.494l-.4-2.106H6.525v6.319h7.6z"
    />
  </BaseIcon>
)
